import React from 'react';
import TimelineItem from '../components/TimelineItem';

export const sections = [
  {
    title: "about",
    content: (
      <p>
        im Sid and im currently a software engineer at BlackRock. i grew up in bangalore, and went to school at UCLA majoring in CS + Math. i grew up playing and following a lot of tennis, and solving rubik's cubes competitively.
        <br /><br />
        currently exploring the potential for <a href="https://tryfisca.com" target="_blank" rel="noopener noreferrer" className="fisca-link">agents in accounts receivables</a>.
        <br /><br />
        feel free to reach out!
      </p>
    )
  },
  {
    title: "experience",
    content: (
      <div className="timeline-container">
        <TimelineItem
          year="2025 –"
          title="swe"
          company="BlackRock"
          location="NYC"
          description="Continuing work on Aladdin Wealth Tech"
          logo="/logos/blackrock.png"
          url="https://www.blackrock.com/aladdin/products/aladdin-wealth"
        />
        <TimelineItem
          year="2024"
          title="swe intern"
          company="BlackRock"
          location="NYC"
          description="Built new features into Aladdin Wealth Tech"
          logo="/logos/blackrock.png"
          url="https://www.blackrock.com/aladdin/products/aladdin-wealth"
        />
        <TimelineItem
          year="2023"
          title="swe intern"
          company="Siemens"
          location="Costa Mesa"
          description="Implemented 'autorouting' feature for NX CAD"
          logo="/logos/siemens.png"
          url="https://www.siemens.com"
        />
        <TimelineItem
          year="2023"
          title="founder"
          company="Ryze"
          location="LA"
          description="Educational AI chrome extension, scaled to 5k+ users"
          logo="/logos/ryze.png"
        />
        <TimelineItem
          year="2022"
          title="swe intern"
          company="Open.Money"
          location="Bangalore"
          description="Full stack work on transactions dashboard"
          logo="/logos/openmoney.png"
          url="https://www.open.money"
        />
      </div>
    )
  }
];
